import { useContext } from 'react';
import CommunicationContext from './CommunicationContext';

export default () => useContext(CommunicationContext);
